import { LAB_ABBREVIATIONS } from "@/configuration/lab-abbreviations";
import type { FieldTransformConfig } from "@/configuration/transform-config";

export const PINNACLE_PRIORITY_ABBREVIATIONS: readonly string[] = ["CMP", "CBC", "HgbA1C"] as const;

export const PINNACLE_TRANSFORM_CONFIG: FieldTransformConfig = {
  listOfNameOfLabs: {
    maxLength: 45,
    maxRange: 2,
    abbreviations: LAB_ABBREVIATIONS,
    priorityAbbreviations: PINNACLE_PRIORITY_ABBREVIATIONS,
  },
  specialty: { emptyValue: "" },
};
